import React from 'react'
export default () => (
  <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
    <path d="M0.00667605634,19.9251549 L19.9251737,0.006657277" id="Stroke-1" />
    <path d="M0.00667605634,0.006657277 L19.9251737,19.9251549" id="Stroke-3" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/closeIcon.js